import { useCallback, useMemo, useState } from 'react';

export const DEFAULT_PAGE_SIZE = 20;

export function usePaginatedList<T>(items: T[], pageSize = DEFAULT_PAGE_SIZE) {
  const [visibleCount, setVisibleCount] = useState(pageSize);

  const visibleItems = useMemo(
    () => items.slice(0, visibleCount),
    [items, visibleCount]
  );

  const hasMore = visibleCount < items.length;
  const totalCount = items.length;

  const showMore = useCallback(() => {
    setVisibleCount((current) => Math.min(current + pageSize, items.length));
  }, [items.length, pageSize]);

  const reset = useCallback(() => {
    setVisibleCount(pageSize);
  }, [pageSize]);

  return {
    visibleItems,
    totalCount,
    visibleCount: Math.min(visibleCount, items.length),
    hasMore,
    showMore,
    reset,
    pageSize,
  };
}
